import { useEffect, useState } from "react";

const useMediaQuery = (minWidth) => {
    const currWidth = window.innerWidth;
    const [state, setState] = useState({
        windowWidth: currWidth,
        isDesiredWidth: (currWidth < minWidth),
    });

    useEffect(() => {
        const resizeHandler = () => {
            const currentWindowWidth = window.innerWidth;
            const isDesiredWidth = currentWindowWidth < minWidth;
            setState({ windowWidth: currentWindowWidth, isDesiredWidth });
        };
        window.addEventListener("resize", resizeHandler);
        return () => window.removeEventListener("resize", resizeHandler);
    }, [state.windowWidth]);

    return state.isDesiredWidth;
};

export default useMediaQuery;
